const toFahrenheit = (degrees) => degrees * (9 / 5) + 32;
const formatDegreeStatistic = (rawResult, temperatureUnit) => {
    const value = parseFloat(rawResult);
    const unroundedResult = temperatureUnit === 'celsius' ? value : toFahrenheit(value);
    const result = parseFloat(unroundedResult.toPrecision(3)); // 3 significant figures;
    return result;
};
export default formatDegreeStatistic;
